import React from "react";
import { Routes, Route } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { CartProvider } from "./context/CartContext";
import { ProductProvider } from "./context/ProductContext";
import CartDrawer from "./components/Cart/CartDrawer";
import Home from "./pages/Home/Home";
import Collection from "./pages/Collection/Collection";
import ProductDetail from "./pages/Product/ProductDetail";
import Checkout from "./pages/Checkout/Checkout";
import OrderConfirmed from "./pages/Checkout/OrderConfirmed";
import AboutPage from "./pages/About/About";
import "./index.css";

function App() {
	return (
		<ProductProvider>
		<CartProvider>
			<div className="App">
				<Toaster
					position="top-right"
					toastOptions={{
						duration: 4000,
						style: {
							background: '#1A1A1A',
							color: '#FFFFFF',
							fontFamily: 'Montserrat, sans-serif',
							fontSize: '13px',
							borderRadius: '0',
						},
						success: {
							style: {
								background: '#4CAF50',
							},
						},
						error: {
							style: {
								background: '#F44336',
							},
						},
					}}
				/>
				<CartDrawer />
				<Routes>
					<Route path="/" element={<Home />} />
					<Route path="/collections" element={<Collection />} />
					<Route path="/collections/:categorySlug" element={<Collection />} />
					<Route path="/product/:slug" element={<ProductDetail />} />
					<Route path="/checkout" element={<Checkout />} />
					<Route path="/order-confirmed" element={<OrderConfirmed />} />
					<Route path="/about" element={<AboutPage />} />
				</Routes>
			</div>
		</CartProvider>
		</ProductProvider>
	);
}

export default App;
